<!-- common component for registration form: both for registration through company and through bloom -->
<template>
  <form v-on:submit.prevent="serverValidation">
    <div class="form-wrap">
      <div class="form-sep-block">
        <h3>基本情報</h3>
        <div class="item-form-block">
          <div class="form-group row">
            <div class="col-6 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                氏名
              </label>
              <input
                type="text"
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('last_name'),
                }"
                name="last_name"
                v-model="formData.last_name"
                v-validate="'required|max:30'"
                data-vv-as="姓"
                placeholder="例）山田"
              />
              <div class="invalid-feedback" v-if="hasError('last_name')">
                {{ getErrorMessage('last_name') }}
              </div>
            </div>
            <!-- full_name is first_name -->
            <div class="col-6 mb-30">
              <label class="cstm-label">&nbsp;</label>
              <input
                type="text"
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('full_name'),
                }"
                name="full_name"
                v-model="formData.full_name"
                v-validate="'required|max:30'"
                data-vv-as="名"
                placeholder="例）太郎"
              />
              <div class="invalid-feedback" v-if="hasError('full_name')">
                {{ getErrorMessage('full_name') }}
              </div>
            </div>
            <div class="col-12">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                ふりがな
              </label>
            </div>
            <div class="col-6 mb-30">
              <input
                type="text"
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('last_furigana'),
                }"
                name="last_furigana"
                v-model="formData.last_furigana"
                v-validate="'required|max:30'"
                data-vv-as="せい"
                placeholder="例）やまだ"
              />
              <div class="invalid-feedback" v-if="hasError('last_furigana')">
                {{ getErrorMessage('last_furigana') }}
              </div>
            </div>
            <div class="col-6 mb-30">
              <!-- <label class="cstm-label">&nbsp;</label> -->
              <input
                type="text"
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('furigana'),
                }"
                name="furigana"
                v-model="formData.furigana"
                v-validate="'required|max:30'"
                data-vv-as="めい"
                placeholder="例）たろう"
              />
              <div class="invalid-feedback" v-if="hasError('furigana')">
                {{ getErrorMessage('furigana') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                性別
              </label>
              <div class="d-flex justify-content-start">
                <div class="custom-control custom-radio">
                  <input
                    class="custom-control-input radio-input"
                    type="radio"
                    name="gender"
                    data-vv-as="性別"
                    v-bind:class="{
                      'is-invalid': hasError('gender'),
                    }"
                    v-model="formData.gender"
                    id="exampleRadios0"
                    value="指定なし"
                    v-validate="'required'"
                  />
                  <label
                    class="custom-control-label cstm-label radio-label"
                    for="exampleRadios0"
                  >
                    指定なし
                  </label>
                </div>
                <div class="custom-control custom-radio ml-5">
                  <input
                    class="custom-control-input radio-input"
                    type="radio"
                    name="gender"
                    data-vv-as="性別"
                    v-bind:class="{
                      'is-invalid': hasError('gender'),
                    }"
                    v-model="formData.gender"
                    id="exampleRadios1"
                    value="男性"
                    v-validate="'required'"
                  />
                  <label
                    class="custom-control-label cstm-label radio-label"
                    for="exampleRadios1"
                  >
                    男性
                  </label>
                </div>
                <div class="custom-control custom-radio ml-5">
                  <input
                    class="custom-control-input radio-input"
                    type="radio"
                    name="gender"
                    data-vv-as="性別"
                    v-bind:class="{
                      'is-invalid': hasError('gender'),
                    }"
                    v-model="formData.gender"
                    id="exampleRadios2"
                    value="女性"
                    v-validate="'required'"
                  />
                  <label
                    class="custom-control-label cstm-label radio-label"
                    for="exampleRadios2"
                  >
                    女性
                  </label>
                </div>
              </div>
              <div class="invalid-feedback" v-if="hasError('gender')">
                {{ getErrorMessage('gender') }}
              </div>
            </div>
            <div class="col-lg-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                生年月日
              </label>
              <div class="d-flex justify-content-between slct-inline">
                <select
                  class="form-control"
                  v-bind:class="{
                    'is-invalid': hasError('year'),
                  }"
                  name="year"
                  v-model="birth_date.year"
                  v-validate="'required'"
                  data-vv-as="生年月日"
                >
                  <!-- <option value="">年</option> -->
                  <option
                    v-for="year in years"
                    v-bind:key="year"
                    v-bind:value="year"
                  >
                    {{ year }}
                  </option>
                </select>
                <label class="d-flex  flex-column justify-content-center mr-4 font-16">年</label>
                <select
                  class="form-control"
                  v-bind:class="{
                    'is-invalid': hasError('month'),
                  }"
                  name="month"
                  v-model="birth_date.month"
                  v-validate="'required'"
                  data-vv-as="生年月日"
                >
                  <!-- <option value="">月</option> -->
                  <option
                    v-for="month in months"
                    v-bind:key="month"
                    v-bind:value="month"
                  >
                    {{ month }}
                  </option>
                </select>
                <label class="d-flex flex-column justify-content-center mr-4 font-16">月</label>
                <select
                  class="form-control"
                  v-bind:class="{
                    'is-invalid': hasError('day'),
                  }"
                  name="day"
                  v-model="birth_date.day"
                  v-validate="'required'"
                  data-vv-as="生年月日"
                >
                  <!-- <option value="">日</option> -->
                  <option
                    v-for="day in days"
                    v-bind:key="day"
                    v-bind:value="day"
                  >
                    {{ day }}
                  </option>
                </select>
                <label class="d-flex flex-column justify-content-center font-16">日</label>
              </div>
              <div
                class="invalid-feedback"
                v-if="hasError('day') || hasError('month') || hasError('year')"
              >
                生年月日は必須項目です
              </div>
              <div class="invalid-feedback" v-if="hasError('birth_date')">
                {{ getErrorMessage('birth_date') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                居住地
              </label>
              <select
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('residence'),
                }"
                name="residence"
                v-model="formData.residence"
                v-validate="'required'"
                data-vv-as="居住地"
              >
                <option value="">選択</option>
                <option
                  v-for="residence in data.residence"
                  v-bind:key="residence._id"
                  :value="residence._id"
                >
                  {{ residence.title }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="hasError('residence')">
                {{ getErrorMessage('residence') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                メールアドレス
              </label>
              <input
                type="email"
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('email'),
                }"
                name="email"
                v-model="formData.email"
                v-validate="'required|email'"
                data-vv-as="メールアドレス"
                autocomplete="new-password"
              />
              <div class="invalid-feedback" v-if="hasError('email')">
                <span
                  class="error-link"
                  v-html="getErrorMessage('email')"
                ></span>
              </div>
              <!-- ※携帯キャリアメール（docomo・au・softbank等）は、認証メールが届かない場合があります。
    別のメールアドレスを入力いただく事を推奨します。 -->
              <p class="sml-note">
                ※携帯キャリアメール
                <span style="text-transform:lowercase;"></span>
                <span style="">（docomo・au・softbank等）</span>
                は、認証メールが届かない場合があります。
                <span style="text-transform:lowercase;"></span>
                別のメールアドレスを入力いただく事を推奨します。
              </p>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                パスワード設定（8文字以上）
              </label>
              <input
                type="password"
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('password'),
                }"
                name="password"
                v-model="formData.password"
                v-validate="'required|doubleByte|min:8'"
                ref="password"
                autocomplete="new-password"
                data-vv-as="パスワード"
              />
              <div class="invalid-feedback" v-if="hasError('password')">
                {{ getErrorMessage('password') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                パスワード再入力
              </label>
              <input
                type="password"
                class="form-control is-valid"
                v-bind:class="{
                  'is-invalid': hasError('password_confirmation'),
                }"
                name="password_confirmation"
                v-model="formData.password_confirmation"
                v-validate="'required|confirmed:password'"
                data-vv-as="パスワード"
              />
              <div
                class="invalid-feedback"
                v-if="hasError('password_confirmation')"
              >
                {{ getErrorMessage('password_confirmation') }}
              </div>
            </div>
            <!-- <div class="col-12 mb-30">
                        <label class="cstm-label">電話番号 <span class="span-badge ml-2">必須</span></label>
                        <input type="text" class="form-control"
                                v-bind:class="{ 'is-invalid': hasError('phone') }" name="phone"
                                v-model="formData.phone"
                                v-validate="'required|numeric|length:11'"
                                data-vv-as="電話番号">
                        <div class="invalid-feedback" v-if="hasError('phone')">
                            {{getErrorMessage('phone')}}
                        </div>
                        </div> -->
            <!-- <div class="col-12 mb-30">
                        <label class="cstm-label">写真アップロード（任意）<span class="span-badge ml-2">必須</span></label>
                        <div class="custom-file">
                            <input name="image" type="file" class="custom-file-input"
                            v-on:change="onFileChanged"
                            v-bind:class="{'is-invalid' : hasError('image') }"
                            v-validate="'image'"
                            data-vv-as="写真アップロード（任意）">
                            <label class="custom-file-label">{{formData.image_name}}</label>
                        </div>
                        <div class="invalid-feedback" v-if="hasError('image')">
                            {{getErrorMessage('image')}}
                        </div>
                        </div> -->
          </div>
        </div>
        <!-- ends item-form-block -->
      </div>
      <!-- ends form-sep-block -->

      <div class="form-sep-block">
        <h3>学歴</h3>
        <div class="item-form-block">
          <div class="form-group row">
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                最終学歴
              </label>
              <select
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('final_education'),
                }"
                name="final_education"
                v-model="formData.final_education"
                v-validate="'required'"
                data-vv-as="最終学歴"
              >
                <option value="">選択</option>
                <option
                  v-for="finalEducation in data.finalEducation"
                  v-bind:key="finalEducation._id"
                  :value="finalEducation._id"
                >
                  {{ finalEducation.title }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="hasError('final_education')">
                {{ getErrorMessage('final_education') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                卒業学校名
              </label>
              <input
                type="text"
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('graduation_school_name'),
                }"
                name="graduation_school_name"
                v-model="formData.graduation_school_name"
                v-validate="'required|max:50'"
                data-vv-as="卒業学校名"
              />
              <div
                class="invalid-feedback"
                v-if="hasError('graduation_school_name')"
              >
                {{ getErrorMessage('graduation_school_name') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                卒業学部名
              </label>
              <input
                type="text"
                class="form-control department-form"
                v-bind:class="{
                  'is-invalid': hasError('graduation_department_name'),
                }"
                name="graduation_department_name"
                v-model="formData.graduation_department_name"
                v-validate="'required|max:50'"
                data-vv-as="卒業学部名"
                placeholder="　ない場合は「なし」と入力してください"
              />
              <div
                class="invalid-feedback"
                v-if="hasError('graduation_department_name')"
              >
                {{ getErrorMessage('graduation_department_name') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                卒業年月
              </label>
              <div
                class="d-flex justify-content-between slct-inline graduation-date"
              >
                <select
                  class="form-control"
                  v-bind:class="{
                    'is-invalid': errors.first('year_of_graduation'),
                  }"
                  name="year_of_graduation"
                  v-model="formData.year_of_graduation"
                  v-validate="'required'"
                  data-vv-as="卒業年月"
                >
                  <!-- <option value=""></option> -->
                  <option
                    v-for="year in years_of_graduation"
                    v-bind:key="year"
                    v-bind:value="year"
                  >
                    {{ year }}
                  </option>
                </select>
                <label for="years">年</label>
                <select
                  class="form-control mr-4 pristine-untouched"
                  v-bind:class="{
                    'is-invalid': errors.first(
                      'month_of_graduation',
                      'academic'
                    ),
                  }"
                  name="month_of_graduation"
                  v-model="formData.month_of_graduation"
                  v-validate="'required'"
                  data-vv-as="卒業年月"
                >
                  <!-- <option value=""></option> -->
                  <option v-for="month in months" :key="month" :value="month">
                    {{ month }}
                  </option>
                </select>
                <label for="months">月</label>
              </div>
              <div
                class="invalid-feedback"
                v-if="hasError('year_of_graduation', 'academic') || hasError('month_of_graduation', 'academic') "
              >
                {{ getErrorMessage('year_of_graduation', 'academic') || getErrorMessage('month_of_graduation', 'academic') }}
              </div>
            </div>
          </div>
        </div>
        <!-- ends item-form-block -->
      </div>
      <!-- ends form-sep-block -->

      <div class="form-sep-block">
        <h3>職歴</h3>
        <div class="item-form-block">
          <div class="form-group row">
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                直近在籍企業名
              </label>
              <input
                type="text"
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('recent_registered_company_name'),
                }"
                name="recent_registered_company_name"
                v-model="formData.recent_registered_company_name"
                v-validate="'required|max:50'"
                data-vv-as="直近在籍企業名"
              />
              <div
                class="invalid-feedback"
                v-if="hasError('recent_registered_company_name')"
              >
                {{ getErrorMessage('recent_registered_company_name') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                在籍期間
              </label>
              <div>
                <input
                  type="checkbox"
                  id="currently_enrolled"
                  class="form-check-inline"
                  name="currently_enrolled"
                  v-model="formData.currently_enrolled"
                />
                <label for="currently_enrolled" class="font-15">
                  在籍中
                </label>
                <div
                  class="d-flex justify-content-between slct-inline enrolled-date"
                >
                  <div class="d-inline-flex flex-basis-100">
                    <select
                      class="form-control"
                      v-bind:class="{
                        'is-invalid': hasError('enrollment_period_from'),
                      }"
                      name="enrollment_period_from"
                      id="from_year"
                      v-model="enrollment_period.from.year"
                      v-validate="'required'"
                      data-vv-as="在籍開始年月"
                    >
                      <option value=""></option>
                      <option
                        v-for="year in enrollmentYears"
                        v-bind:key="year"
                        v-bind:value="year"
                      >
                        {{ year }}
                      </option>
                    </select>
                    <label for="from_year">年</label>

                    <select
                      class="form-control"
                      v-bind:class="{
                        'is-invalid': hasError('enrollment_period_from'),
                      }"
                      name="enrollment_period_from"
                      id="from_month"
                      v-model="enrollment_period.from.month"
                      v-validate="'required'"
                      data-vv-as="在籍開始年月"
                    >
                      <option value=""></option>
                      <option
                        v-for="month in months"
                        v-bind:key="month"
                        v-bind:value="month"
                      >
                        {{ month }}
                      </option>
                    </select>
                    <label for="from_month">月</label>
                  </div>
                  <span class="">~</span>
                  <div class="d-inline-flex flex-basis-100">
                    <select
                      class="form-control"
                      v-bind:class="{
                        'is-invalid': hasError('enrollment_period_to'),
                        disabled: formData.currently_enrolled,
                      }"
                      name="enrollment_period_to"
                      id="to_year"
                      v-model="enrollment_period.to.year"
                      v-validate="{
                        required: !formData.currently_enrolled,
                      }"
                      data-vv-as="在籍終了年月"
                      :disabled="formData.currently_enrolled"
                    >
                      <option value=""></option>
                      <option
                        v-for="year in enrollmentYears"
                        v-bind:key="year"
                        v-bind:value="year"
                      >
                        {{ year }}
                      </option>
                    </select>
                    <label for="to_year">年</label>

                    <select
                      class="form-control"
                      v-bind:class="{
                        'is-invalid': hasError('enrollment_period_to'),
                        disabled: formData.currently_enrolled,
                      }"
                      name="enrollment_period_to"
                      id="to_month"
                      v-model="enrollment_period.to.month"
                      v-validate="{
                        required: !formData.currently_enrolled,
                      }"
                      data-vv-as="在籍終了年月"
                      :disabled="formData.currently_enrolled"
                    >
                      <option value=""></option>
                      <option
                        v-for="month in months"
                        v-bind:key="month"
                        v-bind:value="month"
                      >
                        {{ month }}
                      </option>
                    </select>
                    <label for="to_month">月</label>
                  </div>
                </div>
                <div
                  class="invalid-feedback flex-column align-items-start"
                  v-if="
                    hasError('enrollment_period_from') ||
                      hasError('enrollment_period_to')
                  "
                >
                  <div v-if="hasError('enrollment_period_from')">
                    {{ getErrorMessage('enrollment_period_from') }}
                  </div>
                  <div v-if="hasError('enrollment_period_to')">
                    {{ getErrorMessage('enrollment_period_to') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                直近職種（大分類）
              </label>
              <select
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('latest_occupation_main_title'),
                }"
                name="latest_occupation_main_title"
                v-model="formData.latest_occupation_main_title"
                v-validate="'required'"
                data-vv-as="直近職種 （大分類）"
              >
                <option value="">選択</option>
                <option
                  v-for="occupation in data.latestOccupation"
                  v-bind:key="occupation._id"
                  v-bind:value="occupation._id"
                >
                  {{ occupation.title }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="hasError('latest_occupation_main_title')"
              >
                {{ getErrorMessage('latest_occupation_main_title') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                直近職種（中分類）
              </label>
              <select
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('latest_occupation_sub_title'),
                }"
                name="latest_occupation_sub_title"
                v-model="formData.latest_occupation_sub_title"
                v-validate="'required'"
                data-vv-as="直近職種（中分類）"
              >
                <option value="">選択</option>
                <option
                  v-for="occupation in latestOccupationChilds"
                  v-bind:key="occupation._id"
                  v-bind:value="occupation._id"
                >
                  {{ occupation.title }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="hasError('latest_occupation_sub_title')"
              >
                {{ getErrorMessage('latest_occupation_sub_title') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                雇用形態
              </label>
              <select
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('employment_status'),
                }"
                name="employment_status"
                v-model="formData.employment_status"
                v-validate="'required'"
                data-vv-as="雇用形態"
              >
                <option value="">選択</option>
                <option
                  v-for="status in data.status"
                  v-bind:key="status._id"
                  v-bind:value="status._id"
                >
                  {{ status.title }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="hasError('employment_status')"
              >
                {{ getErrorMessage('employment_status') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge badge-option mr-2">
                  任意
                </span>
                役職
              </label>
              <select
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('position'),
                }"
                name="position"
                v-model="formData.position"
                data-vv-as="役職"
              >
                <option value="">選択</option>
                <option
                  v-for="position in data.position"
                  v-bind:key="position._id"
                  v-bind:value="position._id"
                >
                  {{ position.title }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="hasError('position')">
                {{ getErrorMessage('position') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                英語力
              </label>
              <select
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('english_skills'),
                }"
                name="english_skills"
                v-model="formData.english_skills"
                v-validate="'required'"
                data-vv-as="英語力"
              >
                <option value="">選択</option>
                <option
                  v-for="englishSkill in data.englishSkill"
                  v-bind:key="englishSkill._id"
                  v-bind:value="englishSkill._id"
                >
                  {{ englishSkill.title }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="hasError('english_skills')">
                {{ getErrorMessage('english_skills') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                直近年収 (万円)
              </label>
              <input
                type="number"
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('last_year_income'),
                }"
                name="last_year_income"
                v-model="formData.last_year_income"
                v-validate="'required|numeric|max_value:99999'"
                data-vv-as="直近年収 (万円)"
                min="0"
                onkeypress="return event.charCode >= 48"
              />
              <div class="invalid-feedback" v-if="hasError('last_year_income')">
                {{ getErrorMessage('last_year_income') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                これまでの経験社数
              </label>
              <input
                type="number"
                class="form-control"
                v-bind:class="{
                  'is-invalid': hasError('number_of_experience_companies'),
                }"
                name="number_of_experience_companies"
                v-model="formData.number_of_experience_companies"
                v-validate="'required|numeric'"
                data-vv-as="これまでの経験社数"
                min="0"
                onkeypress="return event.charCode >= 48"
              />
              <div
                class="invalid-feedback"
                v-if="hasError('number_of_experience_companies')"
              >
                {{ getErrorMessage('number_of_experience_companies') }}
              </div>
            </div>
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge mr-2">必須</span>
                職務経歴について
              </label>
              <!-- New block Added by krishna -->

              <div>
                <div id="resumeUpload">
                  <div class="d-flex justify-content-center mb-2">
                    <div
                      class="cstm-upload-block d-flex justify-content-evenly w-100 flex-wrap"
                    >
                      <label for="upld" class="btn btn-cstm-sm btn-black">
                        職務経歴書をアップロードする
                      </label>
                      <input
                        type="file"
                        id="upld"
                        name="resume"
                        v-on:change="onResumeFileChanged"
                        v-bind:class="{
                          'is-invalid': hasError('resume'),
                        }"
                        v-validate="
                          formData.resume_file_name === ''
                            ? ''
                            : 'ext:pdf|size:1024'
                        "
                        accept=".pdf"
                        ref="file_upload_ref"
                      />
                    </div>
                  </div>
                  <div class="upld-file-name mb-3 pb-1" v-if="formData.resume_file_name !== ''">
                      <p style="max-width: 80vw !important">{{ formData.resume_file_name }}</p>
                      <i class="fas fa-times" aria-hidden="true" style="font-size: 25px;margin-left:10px" @click="onResumeDeleteFile"></i>
                  </div>
                  <div class="invalid-feedback" v-if="hasError('resume')">
                      {{ getErrorMessage('resume') }}
                    </div>
                    <div class="invalid-feedback" v-if="resumeCustom">
                      {{ getCustomError('resume') }}
                  </div>
                  <div class="file-instr">
                    <p>
                      <span style="font-size:14px;color: #3d3d3d">
                        アップロードした内容は、あなたがキャリア登録先として選択した企業に公開されます。
                      </span>
                      <br />
                      ・1MB未満のPDFのアップロードが可能です。
                      <br />
                      ・パスワードを設定したPDFはアップロードできません。
                      <br />
                      ・志望動機の記入は不要です。
                    </p>
                  </div>
                </div>
                <div id="job-smry" style="position: relative">
                  <textarea
                    class="form-control"
                    rows="4"
                    v-bind:class="{
                      'is-invalid': hasError('job_summary'),
                    }"
                    name="job_summary"
                    v-model="formData.job_summary"
                    data-vv-as="職務要約"
                    ref="jobSummary_ref"
                    placeholder="職務経歴書がない方は、ここに具体的な業務内容を入力してください"
                    style="height: 170px"
                    v-validate="formData.resume_file_name
                        ? ''
                        : 'required'"
                  ></textarea>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="invalid-feedback"
                      v-if="hasError('job_summary')"
                    >
                      {{ getErrorMessage('job_summary') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 mb-30" style="display:none;">
              <!--<label class="cstm-label">今後ご転職された場合に叶えたいことや、こだわり等あればお聞かせください。</label>-->

              <!-- commented by krishna -->
              <!-- <label>勤務地、担当業務などにおいて、今後ご転職された場合に叶えたいこと、こだわり等あればお聞かせください。（任意入力。志望理由の記入は不要です）</label>
                        <textarea class="form-control" rows="4"
                        v-bind:class="{ 'is-invalid': hasError('career_change_reason') }"
                        name="career_change_reason"
                        v-model="formData.career_change_reason"
                        data-vv-as="職務要約"
                        ></textarea>
                        <div class="invalid-feedback" v-if="hasError('career_change_reason')">
                            {{getErrorMessage('career_change_reason')}}
                        </div> -->
              <!-- commented by krishna -->
            </div>

            <!-- New Block added by krishna -->
            <div class="col-12 mb-30">
              <label class="cstm-label">
                <span class="span-badge badge-option mr-2">
                  任意
                </span>
                配慮事項について
              </label>
              <div>
                <textarea
                  class="form-control"
                  rows="4"
                  v-bind:class="{
                    'is-invalid': hasError('career_change_reason'),
                  }"
                  name="career_change_reason"
                  v-model="formData.career_change_reason"
                  placeholder="転職時期・勤務地、給与等、特に配慮してほしい事項がある方は、ここに入力してください"
                  data-vv-as="職務要約"
                  style="height:150px"
                ></textarea>
                <div
                  class="invalid-feedback"
                  v-if="hasError('career_change_reason')"
                >
                  {{ getErrorMessage('career_change_reason') }}
                </div>
              </div>
            </div>
            <!-- New Block added by krishna -->

            <!-- commented by krishna -->
            <!-- <div class="col-12 mb-30">
                        <label>※ご経験を活かせる可能性がある募集ポジションがある場合、詳細の職務経歴確認のため、登録先企業から職務経歴書などのご提出を求められる場合がございます。</label>
                        </div> -->
            <!-- commented by krishna -->
          </div>
        </div>
        <!-- ends item-form-block -->
      </div>
      <!-- ends form-sep-block -->
    </div>
    <div class="proceed-block">
      <div
        class="btn-toolbar btn-rg justify-content-center"
        role="toolbar"
        aria-label="Toolbar with button groups"
      >
        <button
          class="btn btn-cstm btn-cstm-primary w-100 mw-370"
          type="submit"
          style="background: #EB0A1E; border-color: #EB0A1E; height: 60px"
          :disabled="submitting"
        >
          入力情報の確認へ
        </button>
      </div>
      <p>
        <a href="https://www.blm.co.jp/" target="_blank">
          © Bloom Inc.
        </a>
      </p>
    </div>
    <!-- ends proceed-block -->
  </form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Vue from 'vue';
import swal from 'sweetalert';
import Api from '../config/api';

export default {
  name: 'BRegistration',
  data() {
    return {
      enrollmentYears: [],
      years: [],
      months: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
      ],
      days: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
      ],
      years_of_graduation: [],
      month_of_graduation: '',
      birth_date: {
        year: '1990',
        month: '',
        day: '',
      },
      latestOccupationChilds: [],
      selectAllCompaniesModel: false,
      enrollment_period: {
        from: {
          year: '',
          month: '',
        },
        to: {
          year: '',
          month: '',
        },
      },
      submitting: false,
      check: true,
      resumeCustom: false,
      fileLength: null,
    };
  },
  props: {
    endpointKey: {
      type: String,
      required: true,
    },
  },
  watch: {
    // eslint-disable-next-line
    'formData.latest_occupation_main_title': function(val) {
      this.setOccupationSubTitle(val);
      this.formData.latest_occupation_sub_title = '';
    },
    // eslint-disable-next-line
    'birth_date.year': function() {
      this.birthDateChanged();
    },
    // eslint-disable-next-line
    'birth_date.month': function() {
      this.birthDateChanged();
    },
    // eslint-disable-next-line
    'birth_date.day': function() {
      this.birthDateChanged();
    },
    'enrollment_period.from.year': function() {
      this.enrollmentFromChanged();
    },
    'enrollment_period.from.month': function() {
      this.enrollmentFromChanged();
    },
    'enrollment_period.to.year': function() {
      this.enrollmentToChanged();
    },
    'enrollment_period.to.month': function() {
      this.enrollmentToChanged();
    },
    'formData.currently_enrolled': function() {
      this.enrollment_period = {
        from: {
          year: this.enrollment_period.from.year,
          month: this.enrollment_period.from.month,
        },
        to: {
          year: '',
          month: '',
        },
      };
    },
    selectAllCompaniesModel(check) {
      if (check) this.selectAllCompanies();
      else this.unselectAllcompanies();
    },
  },
  computed: {
    ...mapGetters({
      data: 'getData',
      serverErrors: 'getServerErrors',
      formData: 'getFormData',
      //   companyData: 'getCompanyData',
    }),
    styleHeader() {
      return { background: '#006C6B' };
    },
    placeholderText() {
      return `職務経歴書がない方は、ここに具体的な業務内容を入力してください`;
    },
    // styleButton(){
    //   return this.companyData.brand_secondary_color ? {
    //     'background': this.companyData.brand_secondary_color,
    //     'border-color': this.companyData.brand_secondary_color
    //   }
    //           : {
    //     'background': '#000000',
    //     'border-color': '#000000'
    //   };
    // },
  },
  methods: {
    ...mapMutations({
      setServerErrors: 'setServerErrors',
    }),
    ...mapActions({
      setData: 'setData',
      setBloomData: 'setBloomData',
      checkMaintenance: 'checkMaintenance',
      //   checkCompany: 'checkCompany',
    }),
    hasError(field) {
      return (
        field in this.serverErrors || this.errors.first(field) !== undefined
      );
    },
    getCustomError() {
      return '職務経歴書は、1MB未満のPDFファイルをアップロードしてください';
    },
    getErrorMessage(field) {
      if (this.errors.first(field) !== undefined) {
        return this.errors.first(field);
      } else if (field in this.serverErrors) {
        return this.serverErrors[field].msg;
      }
      return '';
    },
    async serverValidation() {
      this.submitting = true;
      this.checkAuthenticated();
      let check = await this.$validator.validate();
      if (
        this.formData.resume_selectedFile &&
        this.formData.resume_selectedFile.size > 1024 * 1024
      ) {
        check = false;
        this.resumeCustom = this.fileLength === 0;
        // this.resumeCustom = true;
      }
      if (check) {
        try {
          const dataform = new FormData();
          Object.keys(this.formData).forEach((key) => {
            if (key !== 'resume_selectedFile' && key !== 'resume_file_name') {
              dataform.append(key, this.formData[key]);
            }
          });

          if (this.formData.resume_selectedFile !== '') {
            dataform.append(
              'resume',
              this.formData.resume_selectedFile,
              this.formData.resume_file_name
            );
          }

          await this.axios({
            method: 'post',
            data: dataform,
            url: Api.url(Api.endpoints[this.endpointKey]),
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          this.setServerErrors({});
          this.submitting = false;
          this.$emit('redirectToPreviewPage');
        } catch (error) {
          console.log(error);
          if (error && error.response && error.response.status === 422) {
            this.setServerErrors(error.response.data);
            Vue.nextTick(() => this.scrollToError());
          } else if (error && error.response && error.response.status === 503) {
            this.$router.push({ name: 'Maintenance' });
          } else {
            swal('', 'Something Went Wrong', 'error');
          }
          this.submitting = false;
          // else {
          //   swal("","Something Went Wrong","error")
          // }
        }
      } else {
        this.submitting = false;
        this.setServerErrors({});
        this.scrollToError();
      }
    },
    clearServerError(name) {
      // clear server error of resume on file change
      const { [name]: exclude, ...newServerError } = this.serverErrors;
      this.setServerErrors({ ...newServerError });
    },
    async onResumeFileChanged(event) {
      try {
        const [...files] = event.target.files;

        if (files.length < 1) {
          this.fileLength = 0;
          if (
            this.formData.resume_selectedFile &&
            this.formData.resume_selectedFile.size > 1024 * 1024
          ) {
            this.resumeCustom = true;
            return;
          }
        }
        const fileBuffer = await files[0].arrayBuffer();
        // console.log(fileBuffer);
        const clone = new File([fileBuffer], files[0].name, {
          type: files[0].type,
        });
        // console.log(clone);
        [this.formData.resume_file_name, this.formData.resume_selectedFile] = [
          clone.name,
          clone,
        ];
        // force update ui
        this.$forceUpdate();
        this.clearServerError('resume');
        // Explicitly checking for errors.
        // Implicit error check for this field will fail: when user submit form with job summary and
        // then again go back and upload resume
        this.resumeCustom = false;
        this.fileLength = null;
        this.$validator.validate('resume');
      } catch (err) {
        // swal("","Something Went Wrong! Please select your file again","error");
        // this.onResumeDeleteFile();
        console.log(err);
      }
    },
    onResumeDeleteFile() {
      this.formData.resume_file_name = '';
      this.formData.resume_selectedFile = '';
      this.$refs.file_upload_ref.value = null;
      this.resumeCustom = false;
      this.clearServerError('resume');
      this.$validator.validate('resume');
    },
    scrollToError() {
      const element = document.getElementsByClassName('invalid-feedback')[0];
      if (element) {
        const parent = element.closest('.mb-30');
        parent.scrollIntoView();
        // console.log(parent.offsetTop - (parent.offsetHeight * 2));
        // console.log(parent.offsetTop);
        // console.log(document.getElementsByClassName('form-detail')[0]);
        // document.getElementsByClassName('form-detail')[0].scrollTop =
        // parent.offsetTop - (parent.offsetHeight * 2);
      }
    },
    birthDateChanged() {
      this.formData.birth_date = `${this.birth_date.year}/${this.birth_date.month}/${this.birth_date.day}`;
    },
    enrollmentFromChanged() {
      this.clearServerError('enrollment_period_from');
      this.formData.enrollment_period_from = `${this.enrollment_period.from.year}/${this.enrollment_period.from.month}`;
    },
    enrollmentToChanged() {
      this.clearServerError('enrollment_period_to');
      this.formData.enrollment_period_to = `${this.enrollment_period.to.year}/${this.enrollment_period.to.month}`;
    },
    initEnrollmentPeriod() {
      const d = new Date();
      const n = d.getFullYear();
      let j = 0;
      for (let i = n - 70; i <= n; i += 1) {
        this.enrollmentYears[j] = i;
        j += 1;
      }
      const fromSplit = this.formData.enrollment_period_from.split('/');
      this.enrollment_period.from.year = fromSplit[0];
      this.enrollment_period.from.month = fromSplit[1];

      if (!this.formData.currently_enrolled) {
        const toSplit = this.formData.enrollment_period_to.split('/');
        this.enrollment_period.to.year = toSplit[0];
        this.enrollment_period.to.month = toSplit[1];
      }
    },
    initBirthDate() {
      const d = new Date();
      const n = d.getFullYear();
      let j = 0;
      for (let i = n - 70; i <= n - 18; i += 1) {
        this.years[j] = i;
        j += 1;
      }
      const arrayBirthDate = this.formData.birth_date.split('/');
      if (arrayBirthDate.length === 3) {
        [
          this.birth_date.year,
          this.birth_date.month,
          this.birth_date.day,
        ] = arrayBirthDate;
      }
    },
    initYearsOfGraduation() {
      const d = new Date();
      const n = d.getFullYear();
      let j = 0;
      for (let i = n - 70; i <= n; i += 1) {
        this.years_of_graduation[j] = i;
        j += 1;
      }
    },
    // scrollToTop() {
    //   const element = document.getElementsByClassName("main-wrapper")[0];
    //   if (element) {
    //     element.scrollIntoView();
    //     // console.log(parent.offsetTop - (parent.offsetHeight * 2));
    //     // console.log(parent.offsetTop);
    //     // console.log(document.getElementsByClassName('form-detail')[0]);
    //     // document.getElementsByClassName('form-detail')[0].scrollTop =
    //     // parent.offsetTop - (parent.offsetHeight * 2);
    //   }
    // },
    setOccupationSubTitle(val) {
      if (val !== '') {
        if (this.data.latestOccupation !== undefined) {
          const parent = this.data.latestOccupation.find(
            ({ _id }) => _id === val
          );
          this.latestOccupationChilds = parent.children
            .filter((child) => child.status !== false)
            .sort((a, b) => a.position - b.position);
        }
      } else {
        this.latestOccupationChilds = [];
      }
    },
    selectAllCompanies() {
      // eslint-disable-next-line no-underscore-dangle
      this.formData.other_companies = this.data.companies.map(
        (company) => company._id
      );
    },
    unselectAllcompanies() {
      this.formData.other_companies = [];
    },
    checkAuthenticated() {
      const isAuthenticated = this.$auth.isAuthenticated();
      if (isAuthenticated) {
        swal({
          title: 'Notice',
          text:
            ' You are currently logged into the system, to re-register, you will be logged out.',
          icon: 'warning',
          buttons: {
            cancel: 'いいえ',
            ok: 'はい',
          },
        }).then((ok) => {
          if (ok) {
            this.$auth.destroyToken();
          } else {
            this.$router.push({ name: 'home' });
          }
        });
      }
    },
  },
  async mounted() {
    this.initEnrollmentPeriod();
    this.initBirthDate();
    this.initYearsOfGraduation();
    // await this.setBloomData(true);
    // this.checkAuthenticated();
    // this.scrollToTop();
    this.setOccupationSubTitle(this.formData.latest_occupation_main_title);
    const { params } = this.$route;
    if (params && params.slug) {
      this.formData.slug = params.slug;
    }
    // this.formData.slug = this.$route.params.slug;
    // const check = await this.checkCompany(this.$route.params.slug);
    // if (!check) this.$router.push({ name: 'Maintenance' });
  },
};
</script>

<style scoped>
.radio-label {
  color: #000000 !important;
}
.radio-input.is-invalid ~ .radio-label::before {
  background-color: #dee2e6 !important;
  border: 1px solid #adb5bd;
}

#currently_enrolled {
  height: 15px;
  width: 15px;
}
.btn-cstm.btn-cv-submit {
  width: 47%;
}

.btn-cstm.btn-cv-delete {
  background-color: #787878;
  font-weight: 500;
  width: 49%;
}
.form-control::placeholder {
  font-weight: 400;
}

/* textarea::placeholder {
  font-weight: 400;
  font-size: 16px;
  color: #787878 !important;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
} */

textarea {
  display: flex;
  align-items: center;
}

.font-15 {
  font-size: 15px;
}

.flex-basis-100 {
  flex-basis: 100%;
}

.graduation-date {
  width: 45%;
}

.graduation-date .form-control {
  margin-right: 5px !important;
}

.graduation-date label {
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
  font-size: 18px;
}

h5 {
  text-align: center;
  font-size: 23px;
}

@media (max-width: 500px) {
  h5 {
    font-size: 15px;
  }
  .graduation-date {
    width: 100% !important;
  }
}

@media (max-width: 767px) {
  .btn-cstm.btn-cv-submit {
    width: 100%;
  }

  .btn-cstm.btn-cv-delete {
    width: 100%;
    margin: 0px !important;
  }
}

@media only screen and (max-width: 992px) {
  .graduation-date {
    width: 100% !important;
  }
  .enrolled-date {
    flex-wrap: wrap;
  }
  .enrolled-date span {
    flex-basis: 100%;
    justify-content: center;
  }
}

.enrolled-date select {
  margin-right: 5px;
}

.enrolled-date span {
  margin-right: 20px;
  display: inline-flex;
  align-items: center;
  font-size: 25px;
  font-weight: 500;
}

.enrolled-date label {
  margin-right: 20px;
  display: inline-flex;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  color: #494949;
}

.disabled {
  background-image: none !important;
}

.mw-370 {
  max-width: 370px;
}

.is-valid {
  background-image: none;
}

.is-invalid {
  background-image: none;
}
.v-center {
  display: flex;
  align-items: center;
}
.justify-content-evenly {
  justify-content: space-evenly;
}
</style>
